import { getEnvVar } from '@studio/environment';

//Webpack  exposes a global variable called __webpack_public_path__ that allows you to set publicUrl during runtime.
//Refer https://webpack.js.org/guides/public-path/

/* eslint-disable import/first */
if (!!getEnvVar('REACT_APP_PUBLIC_URL')) {
  // eslint-disable-next-line no-undef
  __webpack_public_path__ = getEnvVar('REACT_APP_PUBLIC_URL');
}
import React from 'react';
import { createRoot } from 'react-dom/client';
import { ConnectedRouter } from 'connected-react-router';
import { Provider as ReduxProvider, ReactReduxContext } from 'react-redux';
import { getViewPermissions } from '@shoflo/studio-redux/actions';
import App from './App';
import { store, history } from './store';
import reportWebVitals from './reportWebVitals';

import './bootstrap-combined.scss';
import './index.css';
import '@shoflo/polymer/dist/styles/custom-fonts.css';
import { getUserFromSession } from '@shoflo/studio-redux/actions';
import { logEventLoopLag } from '@studio/logger';

logEventLoopLag();

const reduxDevModeCheckFrequency =
  process.env.NODE_ENV === 'development' ? 'always' : 'never';

const root = createRoot(document.getElementById('root'));
root.render(
  <ReduxProvider
    store={store}
    context={ReactReduxContext}
    noopCheck={reduxDevModeCheckFrequency}
  >
    <ConnectedRouter history={history} context={ReactReduxContext}>
      <App />
    </ConnectedRouter>
  </ReduxProvider>
);

store.dispatch(getUserFromSession());
store.dispatch(getViewPermissions());

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
